module.exports = __webpack_public_path__ + "img/ZJ5045.04eac04e.png";